import React from 'react';
import Hero from '../components/Hero';
import ProblemSection from '../components/ProblemSection';
import CapabilitiesSection from '../components/CapabilitiesSection';
import BuiltForSection from '../components/BuiltForSection';
import StreamsSection from '../components/StreamsSection';
import InstitutionSection from '../components/InstitutionSection';
import TrustSection from '../components/TrustSection';
import CTASection from '../components/CTASection';

const HomePage = () => {
  return (
    <>
      <Hero />
      <ProblemSection />
      <CapabilitiesSection />
      <BuiltForSection />
      <StreamsSection />
      <InstitutionSection />
      <TrustSection />
      <CTASection />
    </>
  );
};

export default HomePage;
